"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExecuteFailReason = exports.ExecuteResult = exports.ExecuteType = void 0;
var ExecuteType;
(function (ExecuteType) {
    ExecuteType[ExecuteType["Execute"] = 0] = "Execute";
    ExecuteType[ExecuteType["Undo"] = 1] = "Undo";
    ExecuteType[ExecuteType["Redo"] = 2] = "Redo";
})(ExecuteType = exports.ExecuteType || (exports.ExecuteType = {}));
var ExecuteResult;
(function (ExecuteResult) {
    /** No need to execute */
    ExecuteResult["None"] = "None";
    ExecuteResult["Fail"] = "Fail";
    ExecuteResult["Success"] = "Success";
})(ExecuteResult = exports.ExecuteResult || (exports.ExecuteResult = {}));
var ExecuteFailReason;
(function (ExecuteFailReason) {
    /** Don't know what went wrong */
    ExecuteFailReason["Unknown"] = "Unknown";
    /** action validation failed */
    ExecuteFailReason["ActionError"] = "ActionError";
    /** Operate on unsupported field, view */
    ExecuteFailReason["NotSupport"] = "NotSupport";
    /** table, view name duplicate */
    ExecuteFailReason["NameRepeat"] = "NameRepeat";
    /** The last one, cannot be deleted */
    ExecuteFailReason["LastOne"] = "LastOne";
    /** Field type mismatch */
    ExecuteFailReason["FieldTypeNotMatch"] = "FieldTypeNotMatch";
    /** Passed parameter problem */
    ExecuteFailReason["WrongOptions"] = "WrongOptions";
})(ExecuteFailReason = exports.ExecuteFailReason || (exports.ExecuteFailReason = {}));
//# sourceMappingURL=types.js.map